import apiService from "./apiService";

export const customerService = {
    getCustomers: (url, params) => apiService.get(url, params),
    getCustomer: (url) => apiService.get(url),
    addCustomer: (url, data) => apiService.post(url, data),
    updateCustomer: (url, data) => apiService.put(url, data),
    deleteCustomer: (url) => apiService.delete(url),
    getAllCustomers: (url) => apiService.get(url),
    getCustomerDetails: (url) => apiService.get(url),
    getCustomerInvoices: (url, params) => apiService.get(url, params),
    deleteCustomerInvoice: (url) => apiService.delete(url),
}